<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Number"
                v-model="selectedLuAgency.Number"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Name"
                v-model="selectedLuAgency.Name"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Abr"
                v-model="selectedLuAgency.Abr"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="saveLuAgencyDetails" :disabled="saving" color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuAgency from '@classes/LuAgency'
//templateTODO: import lookup components you plan to use
export default {
  components: {},
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuAgency: new LuAgency(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luAgency', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luAgency', ['saveLuAgency']),
    async validate() {
      this.$refs.form.validate()
    },
    editLuAgency(entry) {
      this.selectedLuAgency = new LuAgency(entry)
      this.modalText = 'Edit Agency'
      this.dialog = !this.dialog
    },
    addLuAgency() {
      this.modalText = 'Insert Agency'
      this.selectedLuAgency = new LuAgency()
      this.dialog = !this.dialog
    },
    saveLuAgencyDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveLuAgency(this.selectedLuAgency.removeRelated()).then(
            (res) => {
              this.$emit('refresh')
              this.selectedLuAgency = new LuAgency()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuAgency = new LuAgency()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
